import { DataPreFilledType } from '../constants';

export const hasSystemFilledFields = (fields: any[]) =>
	fields?.some(field => field.dataPreFilledType === DataPreFilledType.SourceMapped) ||
	false;

export const hasAnnotations = (fields: any[]) =>
	fields?.some(field => field.type.includes('Annotation')) || false;
